/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
export const plugins = [
	'advlist',
	'autolink',
	'lists',
	'link',
	'image',
	'charmap',
	'preview',
	'anchor',
	'searchreplace',
	'visualblocks',
	'code',
	'fullscreen',
	'insertdatetime',
	'media',
	'table',
	'code',
	'help',
	'wordcount'
];

export const toolbar =
	'undo redo | blocks | ' +
	'bold italic forecolor | alignleft aligncenter ' +
	'alignright alignjustify | bullist numlist outdent indent | ' +
	'code | removeformat | help';

export const help_tabs = [
	{
		name: 'membercenter', // new tab
		title: 'MemberCenter',
		items: [
			{
				type: 'htmlpanel',
				html: `
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex; flex-direction: column;">
            <span style="font-weight: 700; margin-bottom: 10px">Action</span>
            <span>First Name</span>
            <span>Last Name</span>
            <span>Email</span>
            <span>Member Type</span>
            <span>Member Status</span>
            <span>Join Date</span>
            <span>Renewal Date</span>
            <span>Payment Amount</span>
          </div>
          <div style="display: flex; flex-direction: column; margin-right: 45px">
            <span style="font-weight: 700; margin-bottom: 10px">Shortcut</span>
            <span>{{first_name}}</span>
            <span>{{last_name}}</span>
            <span>{{email}}</span>
            <span>{{member_type}}</span>
            <span>{{member_status}}</span>
            <span>{{join_date}}</span>
            <span>{{renewal_date}}</span>
            <span>{{amount}}</span>
          </div>
        </div>`
			}
		]
	},
	'shortcuts',
	'keyboardnav',
	'plugins',
	'versions'
];
